import useAppStore from "@/context/store";
import { getSeoInlinks } from "@/services/qingzhou";
import useLaunchBottomVisibility from "@/utils/hooks/useLaunchBottomVisibility";
import { useUpdateEffect } from "ahooks";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import HBButton from "../HBButton";
import HBLogo from "../HBLogo";
import { useLogin } from "../LoginModal";
import { LoginType } from "../LoginModal/login";
import styles from "./index.module.less";

export default function LaunchBottom({ inlinks, disabledModalOpenWidth }) {
  const { login } = useLogin();
  const { user } = useAppStore(({ user }) => ({
    user,
  }));
  const { launchBottomVisible, launchBottomDisabled, launchBottomIsHidePage } =
    useLaunchBottomVisibility();

  const onLogin = useCallback(
    async (type) => {
      if (!user) {
        await login({
          initType: type,
          target: "blank",
          source_location: "底部栏-登录",
        });
      }
    },
    [login, user]
  );

  // 登录了就不用展示了
  if (launchBottomDisabled) {
    return null;
  }

  return (
    <>
      <div
        className={classNames([
          styles.launchBottom,
          !disabledModalOpenWidth ? "modalOpenWidth" : null,
          launchBottomVisible ? styles.active : null,
          launchBottomIsHidePage ? styles.isHome : null,
        ])}
        data-content-source="底部栏"
      >
        <div className={styles.wrap}>
          <div className={styles.left}>
            <div className={styles.img}>
              <HBLogo hasText width={66} height={20} />

              {/* <img
            src="//cdn.dancf.com/fe-assets/img/09b63a4cb94a263380ea9bb8074ec59a.png"
            alt="背景图"
          /> */}
            </div>
            <div className={styles.title}>陪你做生活的设计师</div>
            {/* <TrackerA
              className={styles.more}
              href={"https://g.h5gdvip.com/p/1hb99rsn#1"}
              target="_blank"
              rel="noreferrer nofollow"
              data-gd-click="button_click"
              data-button-name="了解更多"
            >
              了解更多
            </TrackerA> */}
          </div>
          <div className={styles.right}>
            <HBButton
              data-gd-click="button_click"
              data-button-name="立即登录"
              type="primary"
              onClick={() => onLogin(LoginType.PWD)}
            >
              立即登录
            </HBButton>
          </div>
        </div>

        {!launchBottomIsHidePage && <PageInlinks inlinks={inlinks} />}
      </div>
    </>
  );
}

export function PageInlinks({ inlinks }) {
  const router = useRouter();
  const [links, setLinks] = useState(inlinks || []);
  const pathname = router.pathname;
  const isHome = pathname === "/";

  useUpdateEffect(() => {
    getSeoInlinks({
      current_url: isHome ? "home" : window.location.pathname,
      title: document.title,
    }).then((res) => {
      if (res?.length > 0) {
        setLinks(res);
      }
    });
  }, [router]);

  if (!links?.length) {
    return null;
  }

  return (
    <div className={styles.inlinks}>
      你可能感兴趣：
      {links?.map((item, index) => (
        <a key={index} href={item.url} target="_blank" rel="noreferrer">
          {item.keyword}
        </a>
      ))}
    </div>
  );
}
